
export default function writefeatureWithProj(from, to, feature, format, decimals) {
    var result;
    if (decimals) {
        if (from == to) {
            result = format.writeFeature(feature, { decimals: decimals });
        } else {
            if (from != 'EPSG:3857' && to != 'EPSG:3857') {
                var datas = format.writeFeature(feature, {
                    featureProjection: from,
                    dataProjection: 'EPSG:3857'
                });
                var new_features = format.readFeature(datas, {
                    featureProjection: to,
                    dataProjection: 'EPSG:3857'
                });
                result = format.writeFeature(new_features, { decimals: decimals });
            } else {
                result = format.writeFeature(feature, {
                    featureProjection: from,
                    dataProjection: to,
                    decimals: decimals
                });
            }
        }
    } else {
        if (from == to) {
            result = format.writeFeature(feature);
        } else {
            if (from != 'EPSG:3857' && to != 'EPSG:3857') {
                var datas = format.writeFeature(feature, {
                    featureProjection: from,
                    dataProjection: 'EPSG:3857'
                });
                var new_features = format.readFeature(datas, {
                    featureProjection: to,
                    dataProjection: 'EPSG:3857'
                });
                result = format.writeFeature(new_features);
            } else {
                result = format.writeFeature(feature, {
                    featureProjection: from,
                    dataProjection: to
                });
            }
        }
    }
    return result;
};
